var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 20,
    viewBox: "0 0 12 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.17206 16.9563C0.595625 17.5513 0.610661 18.5009 1.20565 19.0773C1.80063 19.6538 2.75026 19.6387 3.3267 19.0437L1.17206 16.9563ZM10 10L11.0773 11.0437C11.6409 10.462 11.6409 9.53797 11.0773 8.95626L10 10ZM3.3267 0.956265C2.75026 0.361277 1.80063 0.346242 1.20565 0.922683C0.610659 1.49912 0.595624 2.44875 1.17206 3.04374L3.3267 0.956265ZM3.3267 19.0437L11.0773 11.0437L8.92268 8.95626L1.17206 16.9563L3.3267 19.0437ZM11.0773 8.95626L3.3267 0.956265L1.17206 3.04374L8.92268 11.0437L11.0773 8.95626Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/RightArrow.da791a7b86bab7e4520566b16a5eebec.svg";
export { ForwardRef as ReactComponent };